"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;

var react_1 = __importDefault(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var ComposedTypo_1 = require("../ComposedTypo");

exports.Card = function (_a) {
  var _b;

  var _c = _a.border,
      border = _c === void 0 ? true : _c,
      _d = _a.transparent,
      transparent = _d === void 0 ? false : _d,
      _e = _a.align,
      align = _e === void 0 ? 'left' : _e,
      title = _a.title,
      text = _a.text,
      type = _a.type,
      className = _a.className;
  return react_1.default.createElement("div", {
    className: clsx_1.default('p-4 h-100', className, (_b = {
      border: border
    }, _b["text-" + align] = align !== 'left', _b['bg-light'] = transparent, _b))
  }, react_1.default.createElement(ComposedTypo_1.ComposedTypo, {
    className: "m-auto"
  }, title && react_1.default.createElement(ComposedTypo_1.ComposedTypo.Title, null, title), text && react_1.default.createElement(ComposedTypo_1.ComposedTypo.Text, {
    variant: transparent && type === 'price' ? 'huge' : 'body'
  }, text)));
};

exports.default = exports.Card;